export default "__VITE_ASSET__Ch$2P9HL__"